/* PDP Mobile Gallery Slider Progress Indicator (Modern-Pattern)

   Insertet einen schwarzen Balken auf grauer Track-Linie unter der
   .product__media-list. Bar-Width entspricht visible-portion / total-width;
   Bar-Position folgt slider scrollLeft. Aktualisiert sich on scroll +
   resize (rAF-throttled).

   Indicator ist via CSS nur <750px sichtbar. Setup laeuft trotzdem auch
   auf Desktop (kostet nichts), weil das Markup gleich ist.
   Idempotent via dataset flag.
*/
(function () {
  function setupProgress(scope) {
    var root = scope || document;
    var lists = root.querySelectorAll('.product__media-list');
    lists.forEach(function (list) {
      if (list.dataset.progressSetup === 'true') return;
      list.dataset.progressSetup = 'true';

      var indicator = document.createElement('div');
      indicator.className = 'gallery-progress-indicator';
      var bar = document.createElement('div');
      bar.className = 'gallery-progress-indicator__bar';
      indicator.appendChild(bar);
      list.parentNode.insertBefore(indicator, list.nextSibling);

      var ticking = false;
      function update() {
        var totalScroll = list.scrollWidth - list.clientWidth;
        if (totalScroll <= 1) {
          indicator.style.visibility = 'hidden';
          return;
        }
        indicator.style.visibility = '';
        var trackWidth = indicator.clientWidth;
        if (trackWidth <= 0) return;
        var visibleRatio = list.clientWidth / list.scrollWidth;
        var barWidth = Math.max(20, trackWidth * visibleRatio);
        var ratio = list.scrollLeft / totalScroll;
        var barX = (trackWidth - barWidth) * ratio;
        bar.style.width = barWidth + 'px';
        bar.style.transform = 'translateX(' + barX + 'px)';
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      }
      list.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // Initial: in case images are not loaded yet, recalculate after a tick
      update();
      setTimeout(update, 200);
      setTimeout(update, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupProgress();
    });
  } else {
    setupProgress();
  }
  document.addEventListener('shopify:section:load', function (event) {
    setupProgress(event.target);
  });
})();
